import LicensesTable from './LicensesTable';

export default LicensesTable;
